export default __webpack_public_path__ + "static/media/safari_scr_2.efd982bc.png";